import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';

export interface StickyEvent {
    target: HTMLElement
    stuck: boolean
}

@Directive({
  selector: '[onSticky]'
})
export class StickyDirective implements AfterViewInit, OnDestroy {

    private observer: IntersectionObserver;

    @Output() onSticky = new EventEmitter<StickyEvent>();

    constructor(private elementRef: ElementRef<HTMLElement>) {  }

    ngAfterViewInit(): void {

        const target = this.elementRef.nativeElement;
        const targetTop = parseInt(window.getComputedStyle(target).getPropertyValue('top').replace('px', ''));
        
        this.observer = new IntersectionObserver(([record]) => {

            this.onSticky.next({target, stuck: record.intersectionRatio < 1});
    
        }, {threshold: [1], rootMargin: `-${targetTop + 1}px 0px 0px 0px`});
             
        this.observer.observe(target);
    }

    ngOnDestroy(): void {

        if(this.observer)
            this.observer.disconnect();
    }
}
